/**
 * This DOM Events utility is used to bind events on the BODY and it handles the callback by the displayed module.
 * When you want to bind an event to the body you should pass the event name, namespace for the event, your module name, the context (LE.context) and the callback
 * You might want to wrap your callback with a specific context before you pass it to this utility.
 *
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var $ = require("jquery");

    var DomEvents = (function () {
        var on = function(eventName, namespace, moduleName, context, callback) {
            var callbackWrapper = function(e) {
                if (e && e.data && e.data.moduleName && e.data.context && e.data.callback) {
                    if (isModuleDisplayed(e.data.context, e.data.moduleName)) {
                        e.data.callback(e);
                    }
                }
            };
            $(document.body).on(eventName + "." + namespace, {moduleName:moduleName, context:context, callback:callback}, _.bind(callbackWrapper, this));
        };

        var off = function(eventName, namespace) {
            $(document.body).off(eventName + "." + namespace);
        };

        var isModuleDisplayed = function(context, moduleName) {
            return (moduleName === "*" || context.getDisplayedModule() === moduleName);
        };

        return {
            on:on,
            off:off
        };
    }());

    return DomEvents;
});
